export default "__VITE_ASSET__DwUogsrk__"